<template>
  <v-app>
    <v-main v-if="!isLoading">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>เข้าสู่ระบบ</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <form ref="form" @submit.prevent="login()">
                  <v-text-field
                    v-model="empCode"
                    name="empCode"
                    label="ชื่อผู้ใช้"
                    type="text"
                    placeholder="ชื่อผู้ใช้"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="password"
                    name="password"
                    label="รหัสผ่าน"
                    type="password"
                    placeholder="รหัสผ่าน"
                    required
                  ></v-text-field>

                  <strong class="mt-2 d-flex primary--text"
                    >ใช้รหัสผ่านเดียวกันกับ ITEASY</strong
                  >

                  <v-btn
                    type="submit"
                    class="mt-4"
                    color="primary"
                    value="log in"
                  >
                    เข้าสู่ระบบ
                  </v-btn>
                  <v-alert
                    v-if="error"
                    dense
                    outlined
                    type="error"
                    class="mt-2"
                  >
                    <strong>{{ error }}</strong>
                  </v-alert>
                </form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'Login',

  data() {
    return {
      empCode: '',
      password: '',
      isLoading: true,
      error: null,
    }
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$store?.getters['auth/token']) {
        this.$router.push({
          name: 'Order',
        })
      }
      setTimeout(() => {
        this.isLoading = false
      }, 100)
    })
  },

  methods: {
    async login() {
      const { empCode, password } = this
      const payload = {
        emp_code: empCode,
        pass: password,
      }
      const { error } = await this.$store.dispatch(
        'auth/login',
        payload,
      )
      this.error = error
    },
  },
}
</script>
